import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { AppState } from '../..';

import { CILNotificationSelection } from '@services/CILNotificationService';

import { getCILNotification, gotoPage, submitSelection } from '../cil-notification.actions';
import {
  CILNotificationComponent,
  CILNotificationComponentPage,
  CILNotificationComponentProperties
} from './cil-notification.component';

// This is used to translate the state of the page to the props on the component
function mapStateToProps(state: AppState): Partial<CILNotificationComponentProperties> {
  return {
    isLoading: state.cilNotification.isLoading,
    token: state.cilNotification.token,
    page: state.cilNotification.page,
    swoTrackingCILOfferId: state.cilNotification.swoTrackingCILOfferId,
    viewModel: state.cilNotification.viewModel,
    warningMessage: state.cilNotification.warningMessage
  };
}

// This should create proxy wrappers for actions used by the component
function mapDispatchToProps(dispatch: Dispatch<AppState>): Partial<CILNotificationComponentProperties> {
  return {
    getViewModel: (swoTrackingCILOfferId: number, contractId: number, key: string) =>
      dispatch(getCILNotification(swoTrackingCILOfferId, contractId, key)),
    gotoPage: (page: CILNotificationComponentPage) => dispatch(gotoPage(page)),
    submitSelection: (selection: CILNotificationSelection, swoTrackingCILOfferId: number, key: string) =>
      dispatch(submitSelection(selection, swoTrackingCILOfferId, key))
  };
}

// Connect function "wires" both of the map functions and returns a wrapper container for the component
export const CILNotification = connect(
  mapStateToProps,
  mapDispatchToProps
)(CILNotificationComponent);



// WEBPACK FOOTER //
// ./src/cil-notification/_components/cli-notification.container.ts